import React from 'react';
import { Tab } from '@mui/material';
import { CountLabel, RecordTabs } from 'components/record-shell/RecordShell';

interface SupplierTabProps {
  tab: string;
  onChange: (newTab: string) => void;
  productsCount?: number;
  banksCount?: number;
}

const SupplierTab: React.FC<SupplierTabProps> = ({ tab, onChange, productsCount, banksCount }) => {
  return (
    <RecordTabs tab={tab} onChange={onChange}>
      <Tab value="main" label="Dados do fornecedor" />
      <Tab value="address" label="Endereço" />
      <Tab value="products" label={<CountLabel label="Produtos" count={productsCount} />} />
      <Tab value="banks" label={<CountLabel label="Dados bancários" count={banksCount} />} />
    </RecordTabs>
  );
};

export default SupplierTab;
